import { Storage } from 'aws-amplify';
import axios from 'axios';
import moment from 'moment';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import * as FaIcons from 'react-icons/fa';
import DownloadIcon from '../../images/download-icon.svg';
import EditIcon from '../../images/edit-icon.svg';
import PushNotiIcon from '../../images/pushnoti-icon.svg';
import DeleteFileModal from './DeleteFileModal';
import EditFileModal from './EditFileModal';
import SendInfoHubNotiModal from './SendInfoHubNotiModal';

const Files = ({ files, loginList, badgeID, showEdit }) => {
    // const [notSelectableRows, setNotSelectableRows] = useState([])
    const [parsedFiles, setParsedFiles] = useState([])
    const [modalInfo, setModalInfo] = useState([])

    const [rowData, setRowData] = useState([])

    const [editFileModal, setOpenEditFileModal] = useState(false)
    const handleEditFileModal = () => setOpenEditFileModal(!editFileModal)

    const [deleteFileModal, setOpenDeleteFileModal] = useState(false)
    const handleDeleteFileModal = () => setOpenDeleteFileModal(!deleteFileModal)

    const [notiModal, setOpenNotiModal] = useState(false)
    const openNotiModal = () => setOpenNotiModal(!notiModal)
    const closeNotiModal = () => setOpenNotiModal(!notiModal)

    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        // Convert the file's ID from string to number
        const convertArray = files.map(({fileID, ...item}) => ({fileID: Number(fileID), ...item}))
        
        setParsedFiles(convertArray)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Edit File
    const editFile = async (file) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/infohub/editfile';
        const fileDetails = {
            fileID: file.fileID,
            categoryID: file.categoryID,
            fileName: file.fileName,
            fileLink: file.fileLink,
            fileType: file.fileType,
            fileSize: file.fileSize,
            employee: file.employee,
            entity: file.entity,
            modifiedBy: file.modifiedBy
        }
        axios.post(url, fileDetails)
        .then(response => 
            alert('File has been successfully modified!'),
            setTimeout(()=>{
                setOpenEditFileModal(!editFileModal)
            }, 500),
            setTimeout(()=>{
                window.location.reload()
            }, 1000)
        )
        .catch(err => console.error(err));
    };

    // Delete File
    const deleteFile = (fileList) => {
        const file = fileList.file
        const requests = [];
        const url = REACT_APP_API_BACKEND_URL + '/api/infohub/deletefile';

        for (let i = 0; i < file.length; i++) {
            requests.push(axios.post(url, {
                fileID: file[i].fileID,
                deletedBy: file[i].deletedBy
            }))
        }

        axios.all(requests)
        .then(axios.spread((...responses) => {
            alert('File has been successfully deleted!');
            setTimeout(()=>{
                setOpenDeleteFileModal(!deleteFileModal)
            }, 500);
            setTimeout(()=>{
                window.location.reload()
            }, 1000);
        })).catch(err => {
            console.error(err)
        })
    };

    function employeeFormatter(cell, row, rowIndex, formatExtraData) {
        let array = row.fileEmployee.split(',')
        let newArray = array.map(item => (item))

        return (
            <>
                {
                    newArray.length > 2 ?
                    `${newArray.length} Emp Types`
                    :
                    row.fileEmployee.replace(/,/g, ", ")
                }
            </>
        ); 
    }

    function entityFormatter(cell, row, rowIndex, formatExtraData) {
        let array = row.fileEntity.split(',')
        let newArray = array.map(item => (item))

        return (
            <>
                {
                    newArray.length > 2 ?
                    `${newArray.length} Entities`
                    :
                    row.fileEntity.replace(/,/g, ", ")
                }
            </>
        );
    }
    
    const sendNotification = (noti) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/infohub/pushnoti';
        const notification = noti.notification
        const requests = [];

        for (let i = 0; i < notification.length; i++) {
            requests.push(axios.post(url, {
                id: notification[i].id,
                title: notification[i].title,
                employee: notification[i].employee.toLowerCase()
            }))
        }

        axios.all(requests)
        .then(axios.spread((...responses) => {
            alert('Notification has been successfully sent!');
            setTimeout(()=>{
                setOpenNotiModal(!notiModal)
            }, 500);
        })).catch(err => {
            console.error(err)
        })
    }

    function optionsFormatter(cell, row, rowIndex, formatExtraData) {
        return (
            <div 
                style={{ 
                    cursor: 'pointer', 
                    lineHeight: 'normal',
                    display: 'flex',
                    justifyContent: 'center'
                }} 
            >
                {/* {(row.createdByID === badgeID ||
                    loginList.some(
                        (item) =>
                            item.permissionName.includes('Admin Role') &&
                            item.permissionType.includes('edit')
                    )) &&
                    showEdit && 
                <Fragment>
                    <img 
                        src={EditIcon}
                        className='table-icon'
                        style={{minWidth: '50px'}} 
                        onClick={() => {handleEditFileModal(); setModalInfo(row)}}
                        alt=''
                    />
                    <img 
                        src={PushNotiIcon}
                        className='table-icon'
                        style={{minWidth: '50px'}}
                        onClick={() => {openNotiModal(); setModalInfo(row)}}
                        alt=''
                    />
                </Fragment>
                } */}
                {(
                    (row.createdByID === badgeID ||
                    loginList.some((item) =>
                        (item.permissionName.includes("Admin Role") && item.permissionType.includes("edit")))
                    ) &&
                    showEdit) ?
                <Fragment>
                    <img 
                        src={EditIcon}
                        className='table-icon'
                        style={{minWidth: '50px'}} 
                        onClick={() => {handleEditFileModal(); setModalInfo(row)}}
                        alt=''
                    />
                    <img 
                        src={PushNotiIcon}
                        className='table-icon'
                        style={{minWidth: '50px'}}
                        onClick={() => {openNotiModal(); setModalInfo(row)}}
                        alt=''
                    />
                </Fragment>
                :
                <Fragment>
                    <img 
                        src={EditIcon}
                        className='table-icon'
                        style={{minWidth: '50px', visibility: 'hidden'}} 
                        onClick={() => {handleEditFileModal(); setModalInfo(row)}}
                        alt=''
                    />
                    <img 
                        src={PushNotiIcon}
                        className='table-icon'
                        style={{minWidth: '50px', visibility: 'hidden'}}
                        onClick={() => {openNotiModal(); setModalInfo(row)}}
                        alt=''
                    />
                </Fragment>
                }
                {/* {((row.createdByID === badgeID ||
                    loginList.some(
                        (item) =>
                            item.permissionName.includes('Admin Role') &&
                            item.permissionType.includes('edit')
                    )) &&
                    showEdit) ?
                <img 
                    src={DownloadIcon} 
                    className='table-icon'
                    style={{minWidth: '50px'}} 
                    onClick={() => {downloadFile(row.fileLink)}} 
                    alt=''
                />
                :
                <img 
                    src={DownloadIcon} 
                    className='table-icon'
                    style={{width: '50px'}} 
                    onClick={() => {downloadFile(row.fileLink)}} 
                    alt=''
                />
                    } */}
                <img 
                    src={DownloadIcon} 
                    className='table-icon'
                    style={{minWidth: '50px'}} 
                    onClick={() => {downloadFile(row.fileLink)}} 
                    alt=''
                />
            </div>
        ); 
    }

    const columns = [
        { 
            dataField: 'categoryName', 
            text: 'Folder Name', 
            sort: true,
            style: {
                textAlign: 'left'
            }
        },
        { 
            dataField: 'fileName', 
            text: 'File Name', 
            sort: true,
            attrs: { width: 550 },
            style: {
                textAlign: 'left'
            }
        },
        { 
            dataField: 'fileType', text: 'Type', sort: true,
            style: {
                textTransform: 'capitalize'
            }
        },
        { 
            dataField: 'fileEmployee', text: 'Visible Employee', sort: true,
            formatter: employeeFormatter,
            attrs: { width: 120 },
        },
        { 
            dataField: 'fileEntity', text: 'Visible Entity', sort: true,
            formatter: entityFormatter,
            attrs: { width: 170 },
        },
        { 
            dataField: 'fileSize', text: 'Size', sort: true,
            attrs: { width: 180 },
        },
        { 
            dataField: 'createdDate', 
            text: 'Created Date', 
            sort: true,
            attrs: { width: 190 },
            csvFormatter: (cell,row) => { 
                return moment(row.createdDate).format('DD/MM/YYYY') 
            },
            formatter: (cell,row) => {
                return <Fragment>{moment(row.createdDate).format('DD MMM YYYY')}</Fragment>
            }
        },
        { dataField: 'createdBy', text: 'Uploaded By', sort: true },
        { 
            dataField: 'edit',
            text: 'Options',
            sort: false,
            csvExport: false,
            formatter: optionsFormatter,
            headerAttrs: { width: 50 },
            attrs: { width: 50, className: "EditRow" }
        }
    ]

    // Retrieve download URL from S3 and open the download link
    async function downloadFile(fileLink) {
        const fileUrl = await Storage.get(fileLink)
        window.open(fileUrl, '_blank')
    }

    // Validate if file is created by current user
    let notSelectableRows = [];
    
    const getNonSelectableRows = (payload, key, stringToCheck) => {
        let nonSelectable = [];

        payload.forEach((obj) => {
            let value = obj[key];
            if (!value.includes(stringToCheck) &&
            !(loginList.some((item) =>
                (item.permissionName.includes("Admin Role") && item.permissionType.includes("edit")))
            )) {
                nonSelectable.push(obj.fileID);
            }
        });

        return nonSelectable;
    };
    
    notSelectableRows = getNonSelectableRows(parsedFiles, "createdByID", badgeID);

    const selectRow = {
        mode: 'checkbox',
        nonSelectable: notSelectableRows,
        // selectionRenderer: (props) => (
        //     <input
        //         type={props.mode}
        //         checked={props.checked}
        //     />
        // ),
        onSelect: (row, isSelect, rowIndex, e) => {
            if (isSelect === true) {
                setRowData((rowData) => [...rowData, row.fileID]);
            } else {
                setRowData((rowData) => rowData.filter((item) => item !== row.fileID));
            }
        },
        onSelectAll: (isSelect, rows, e) => {
            if (isSelect === true) {
                setRowData(rows.map((item) => item.fileID));
            } else 
                setRowData([]);
        }
    };
    
    const { SearchBar, ClearSearchButton } = Search;

    const ExportCSVButton = (props) => {
        const handleClick = () => {
            props.onExport();
        };

        return (
            <Button 
                variant='success' 
                onClick={handleClick} 
                style={{ float: 'right'}}
            >
                Export to CSV
            </Button>
        );
    };

    return (
        <Fragment>
            <ToolkitProvider
                keyField='fileID'
                data={parsedFiles}
                columns={columns}
                search
                exportCSV={{
                    fileName: 'info-hub.csv',
                    noAutoBOM: false
                }}
            >
            {
                props => (
                <div style={{marginTop: '10px'}}>
                    <SearchBar { ...props.searchProps } />
                    <ClearSearchButton { ...props.searchProps } />
                    <ExportCSVButton { ...props.csvProps } />
                    {
                        rowData.length > 0 &&
                        <Button 
                            variant='outline-danger' 
                            onClick={() => {handleDeleteFileModal()}} 
                            style={{ float:'right' }}>
                            <FaIcons.FaTrashAlt size={25} />
                        </Button>
                    }
                    {showEdit ?
                    <BootstrapTable
                        classes='infohub-table'
                        bordered={false}
                        { ...props.baseProps }
                        pagination={paginationFactory()}
                        selectRow={selectRow}
                        headerWrapperClasses='infohub-header'
                        noDataIndication='List is empty.'
                    />
                    :
                    <BootstrapTable
                        classes='infohub-table'
                        bordered={false}
                        { ...props.baseProps }
                        pagination={paginationFactory()}
                        headerWrapperClasses='infohub-header'
                        noDataIndication='List is empty.'
                    />
                    }
                    <EditFileModal
                        show={editFileModal}
                        handleClose={handleEditFileModal}
                        modalInfo={modalInfo}
                        onEdit={editFile}
                    />
                    <DeleteFileModal
                        show={deleteFileModal}
                        handleClose={handleDeleteFileModal}
                        rowData={rowData}
                        onDelete={deleteFile}
                    />
                    <SendInfoHubNotiModal 
                        show={notiModal}
                        handleClose={closeNotiModal}
                        files={modalInfo}
                        onPushNoti={sendNotification}
                    />
                </div>
                )
            }
            </ToolkitProvider>
        </Fragment>
    );
};

export default Files;
